import script from "./allCampaigns.vue?vue&type=script&setup=true&lang=js"
export * from "./allCampaigns.vue?vue&type=script&setup=true&lang=js"

import "./allCampaigns.vue?vue&type=style&index=0&id=ecec945a&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecec945a"]])

export default __exports__